/* bb-b2b.js: behaviour for the commercial machine (B2B) product template.
   Buy fold (bb-b2b-buy): group and colour pick, gallery, station items, quote and
   lease links to WhatsApp, add to cart. The group pick is shared with the glance,
   plan and range sections through [data-b2b-show] blocks.
   Plan (bb-b2b-plan): draws the front elevation and plan to scale.
   Diagram (bb-b2b-diagram): leader lines from each label up to its dot.
   The parent theme already fires GA4 add_to_cart on /cart/add.js, so there is no
   extra tracking event here. Nothing waits for window load: this storefront
   reaches load very late. */
(function () {
  'use strict';
  if (window.__bbB2B) return;
  window.__bbB2B = true;

  var DH = '<svg class="xp-dh" role="img" aria-label="AED"><use href="#xp-dhs"/></svg>';
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function fmtCents(c) {
    var n = c / 100;
    var dec = (Math.round(c) % 100) !== 0;
    return n.toLocaleString('en-US', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 });
  }
  function fmtN(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- shared group state ---------- */
  function setGroup(g) {
    if (!g) return;
    each(document.querySelectorAll('[data-b2b-show]'), function (el) { el.hidden = el.getAttribute('data-b2b-show') !== g; });
    each(document.querySelectorAll('[data-b2b-range]'), function (r) { setRange(r, g); });
    drawAllLines();
  }

  /* ---------- buy fold ---------- */
  function initBuy(box) {
    var D;
    try { D = JSON.parse(box.querySelector('[data-b2b-json]').textContent); } catch (e) { return; }
    var $ = function (s) { return box.querySelector(s); };
    var cur = null;
    D.variants.forEach(function (v) { if (v.id === D.current) cur = v; });
    if (!cur) cur = D.variants[0];
    var qty = 1, set = [], idx = 0;
    var ov = box.querySelector('[data-b2b-lease]');
    var waLinks = [].slice.call(box.querySelectorAll('[data-b2b-wa]'));

    function find(c, g) {
      var hit = null;
      D.variants.forEach(function (v) { if (!hit && (c === null || v.c === c) && (g === null || v.g === g)) hit = v; });
      return hit;
    }
    function coloursIn(g) {
      var out = [];
      D.variants.forEach(function (v) { if ((g === null || v.g === g) && out.indexOf(v.c) < 0) out.push(v.c); });
      return out;
    }
    function galIds(c, g) {
      var G = D.gal || {};
      var ids = G[(c || '') + '|' + (g || '')];
      if (!ids || !ids.length) {
        for (var k in G) { if (k.split('|')[0] === c && G[k].length) { ids = G[k]; break; } }
      }
      if (!ids || !ids.length) ids = Object.keys(D.media || {});
      return ids.filter(function (id) { return D.media[id]; });
    }

    /* gallery */
    function show(i) {
      if (!set.length) return;
      idx = (i + set.length) % set.length;
      var m = D.media[set[idx]], main = $('[data-b2b-main]');
      main.innerHTML = '<img src="' + m.src + '" alt="' + String(m.alt || '').replace(/"/g, '&quot;') + '" width="900" height="900">';
      each(box.querySelectorAll('[data-b2b-thumb]'), function (t, j) { t.classList.toggle('xp-on', j === idx); t.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
      var cnt = $('[data-b2b-count]');
      if (cnt) { cnt.textContent = (idx + 1) + ' / ' + set.length; cnt.hidden = set.length < 2; }
      $('[data-b2b-prev]').hidden = set.length < 2;
      $('[data-b2b-next]').hidden = set.length < 2;
    }
    function buildGallery() {
      set = galIds(cur.c, cur.g);
      var th = $('[data-b2b-thumbs]');
      th.innerHTML = '';
      set.forEach(function (id, j) {
        var m = D.media[id], im = document.createElement('img');
        im.src = m.th; im.alt = m.alt || ''; im.width = 120; im.height = 120; im.loading = 'lazy';
        im.tabIndex = 0; im.setAttribute('role', 'button'); im.setAttribute('data-b2b-thumb', j);
        th.appendChild(im);
      });
      th.hidden = set.length < 2;
      show(0);
    }
    function bindThumbs() {
      $('[data-b2b-thumbs]').addEventListener('click', function (e) { var t = e.target.closest('[data-b2b-thumb]'); if (t) show(+t.getAttribute('data-b2b-thumb')); });
      $('[data-b2b-thumbs]').addEventListener('keydown', function (e) { var t = e.target.closest('[data-b2b-thumb]'); if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); show(+t.getAttribute('data-b2b-thumb')); } });
    }

    /* chips and swatches */
    function chipPrice(g) {
      var own = find(cur.c, g);
      if (own) return own.price;
      var min = null;
      D.variants.forEach(function (v) { if (v.g === g && (min === null || v.price < min)) min = v.price; });
      return min;
    }
    function swatchSrc(c, g) {
      if (D.sw && D.sw[c]) return D.sw[c] + '?width=160';
      var ids = (D.gal || {})[c + '|' + g] || [];
      var id = ids[1] || ids[0];
      return id && D.media[id] ? D.media[id].sw : null;
    }
    function syncControls() {
      each(box.querySelectorAll('[data-b2b-group]'), function (b) {
        var g = b.getAttribute('data-b2b-group'), on = g === cur.g;
        b.classList.toggle('xp-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        var p = chipPrice(g), el = b.querySelector('[data-b2b-gp]');
        if (el && p !== null) el.textContent = fmtCents(p);
      });
      var inG = coloursIn(cur.g);
      each(box.querySelectorAll('[data-b2b-colour]'), function (b) {
        var c = b.getAttribute('data-b2b-colour'), on = c === cur.c;
        b.hidden = inG.indexOf(c) < 0;
        b.classList.toggle('xp-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        var img = b.querySelector('img'), src = swatchSrc(c, cur.g);
        /* a colour sold only in another group is printed as a text swatch; give it its photo once it has one */
        if (!img && src) { img = document.createElement('img'); img.alt = ''; img.width = 80; img.height = 80; var t = b.querySelector('.xp-swtxt'); if (t) t.remove(); b.appendChild(img); }
        if (img && src && img.getAttribute('src') !== src) img.src = src;
      });
      var gn = $('[data-b2b-gname]'); if (gn && cur.g) gn.textContent = cur.g.toLowerCase();
      var cn = $('[data-b2b-cname]'); if (cn && cur.c) cn.textContent = cur.c;
    }

    /* station items */
    function pods() { return [].slice.call(box.querySelectorAll('[data-b2b-pod]')); }
    function podQty(p) { return +(p.querySelector('.xb-pq em') || { textContent: 1 }).textContent || 1; }
    function syncStation() {
      var n = 0, t = 0;
      pods().forEach(function (p) { if (p.classList.contains('xp-on')) { var q = podQty(p); n += q; t += q * (+p.getAttribute('data-price')); } });
      var el = $('[data-b2b-psel]');
      if (el) el.innerHTML = n ? '<b>' + n + ' ' + D.t.added + ' · ' + DH + fmtCents(t) + '</b>' : D.t.hint;
      syncWa();
    }
    function togglePod(p) {
      if (p.getAttribute('aria-disabled') === 'true') return;
      var on = !p.classList.contains('xp-on');
      p.classList.toggle('xp-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!on) { var em = p.querySelector('.xb-pq em'); if (em) em.textContent = '1'; }
      syncStation();
    }
    function stepPod(p, d) {
      var em = p.querySelector('.xb-pq em'), q = podQty(p) + d;
      if (q < 1) { p.classList.remove('xp-on'); p.setAttribute('aria-pressed', 'false'); q = 1; }
      em.textContent = Math.min(q, 20);
      syncStation();
    }

    /* WhatsApp */
    function waText(kind) {
      var W = D.wa, L = [];
      L.push(kind === 'lease' ? W.lease : W.quote);
      var line = qty + ' x ' + W.name;
      if (cur.g) line += ', ' + cur.g.toLowerCase();
      if (cur.c) line += ', ' + cur.c;
      L.push(line);
      pods().forEach(function (p) { if (p.classList.contains('xp-on')) L.push(podQty(p) + ' x ' + p.getAttribute('data-name')); });
      L.push(W.url);
      if (W.outro) L.push(W.outro);
      return L.join('\n');
    }
    function syncWa() {
      waLinks.forEach(function (a) { a.href = 'https://wa.me/' + D.wa.num + '?text=' + encodeURIComponent(waText(a.getAttribute('data-b2b-wa'))); });
    }

    /* cart button */
    function syncCart() {
      var b = $('[data-b2b-add]');
      if (!b) return;
      b.disabled = !cur.available;
      b.textContent = cur.available ? D.t.add : D.t.soldout;
    }

    function pick(v, push) {
      if (!v) return;
      cur = v;
      $('[data-b2b-price]').textContent = fmtCents(cur.price);
      var ex = $('[data-b2b-ex]'); if (ex) ex.textContent = fmtCents(Math.round(cur.price * 100 / 105));
      syncControls(); buildGallery(); syncCart(); syncWa();
      setGroup(cur.g);
      try { document.dispatchEvent(new CustomEvent('xp:variant', { detail: { id: cur.id, available: !!cur.available } })); } catch (e) {}
      if (push) { try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(history.state, '', u.toString()); } catch (e) {} }
    }

    /* events */
    box.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-pq]'))) { e.stopPropagation(); stepPod(t.closest('[data-b2b-pod]'), +t.getAttribute('data-pq')); return; }
      if ((t = e.target.closest('[data-b2b-pod]'))) { togglePod(t); return; }
      if ((t = e.target.closest('[data-b2b-group]'))) {
        var g = t.getAttribute('data-b2b-group');
        if (g === cur.g) return;
        pick(find(cur.c, g) || find(null, g), true); return;
      }
      if ((t = e.target.closest('[data-b2b-colour]'))) {
        var c = t.getAttribute('data-b2b-colour');
        if (c === cur.c) return;
        pick(find(c, cur.g) || find(c, null), true); return;
      }
      if ((t = e.target.closest('[data-b2b-q]'))) { qty = Math.max(1, Math.min(20, qty + (+t.getAttribute('data-b2b-q')))); $('[data-b2b-qn]').textContent = qty; syncWa(); return; }
      if (e.target.closest('[data-b2b-prev]')) { show(idx - 1); return; }
      if (e.target.closest('[data-b2b-next]')) { show(idx + 1); return; }
      if (e.target.closest('[data-b2b-lease-open]')) { openLease(e.target.closest('[data-b2b-lease-open]')); return; }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (t.hasAttribute('data-pq')) { e.preventDefault(); e.stopPropagation(); stepPod(t.closest('[data-b2b-pod]'), +t.getAttribute('data-pq')); return; }
      if (t.hasAttribute('data-b2b-pod')) { e.preventDefault(); togglePod(t); }
    });
    var stg = $('[data-b2b-stage]'), x0 = null;
    if (stg) {
      stg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stg.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); x0 = null; });
    }
    bindThumbs();

    /* add to cart */
    var addBtn = $('[data-b2b-add]'), err = $('[data-b2b-err]');
    if (addBtn) addBtn.addEventListener('click', function () {
      if (!cur.available || addBtn.disabled) return;
      var items = [{ id: cur.id, quantity: qty }];
      pods().forEach(function (p) { if (p.classList.contains('xp-on')) items.push({ id: +p.getAttribute('data-b2b-pod'), quantity: podQty(p) }); });
      addBtn.disabled = true; if (err) err.hidden = true;
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); location.href = root() + 'cart'; })
        .catch(function () { addBtn.disabled = false; if (err) err.hidden = false; });
    });

    /* lease panel: moved to <body> on first open so no ancestor can clip it */
    var opener = null;
    function closeLease() {
      if (!ov || ov.hidden) return;
      ov.hidden = true;
      if (opener) { try { opener.focus(); } catch (e) {} }
    }
    function openLease(btn) {
      if (!ov) return;
      opener = btn;
      if (ov.parentNode !== document.body) document.body.appendChild(ov);
      syncWa();
      ov.hidden = false;
      var c = ov.querySelector('[data-b2b-close]');
      setTimeout(function () { if (c) c.focus(); }, 30);
    }
    if (ov) {
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-b2b-close]')) closeLease(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLease(); });
    }

    set = galIds(cur.c, cur.g); idx = 0;
    syncControls(); syncStation(); syncCart();
    if (cur.g) setGroup(cur.g);
  }

  /* ---------- plan drawing ---------- */
  function dimH(x1, x2, y, t) {
    return '<line class="dm" x1="' + x1 + '" y1="' + y + '" x2="' + x2 + '" y2="' + y + '"/><line class="dm" x1="' + x1 + '" y1="' + (y - 5) + '" x2="' + x1 + '" y2="' + (y + 5) + '"/><line class="dm" x1="' + x2 + '" y1="' + (y - 5) + '" x2="' + x2 + '" y2="' + (y + 5) + '"/><text class="dt" x="' + ((x1 + x2) / 2) + '" y="' + (y - 6) + '" text-anchor="middle">' + t + '</text>';
  }
  function dimV(x, y1, y2, t) {
    var m = (y1 + y2) / 2;
    return '<line class="dm" x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '"/><line class="dm" x1="' + (x - 5) + '" y1="' + y1 + '" x2="' + (x + 5) + '" y2="' + y1 + '"/><line class="dm" x1="' + (x - 5) + '" y1="' + y2 + '" x2="' + (x + 5) + '" y2="' + y2 + '"/><text class="dt" x="' + (x + 8) + '" y="' + (m + 4) + '">' + t + '</text>';
  }
  function planSVG(d, ng, mode, L) {
    var wide = mode === 'wide', s = wide ? 0.3 : 0.24, MAXW = 1150 * s;
    var W = d.w * s, H = d.h * s, D = d.d * s, o = '', vbw, vbh, ex, ey, px, py;
    if (wide) { ex = 20; ey = 58; px = ex + MAXW + 120; py = 58; vbw = px + MAXW + 90; vbh = py + Math.max(H, D) + 48; }
    else { ex = 14; ey = 50; px = 14; py = ey + H + 92; vbw = ex + MAXW + 84; vbh = py + D + 44; }
    var x0 = ex + (MAXW - W) / 2, x1 = px + (MAXW - W) / 2, i, gx;
    o += '<svg class="xb-svg-' + mode + '" viewBox="0 0 ' + vbw + ' ' + vbh + '" role="img" aria-label="' + L.aria.replace('[w]', d.w).replace('[d]', d.d).replace('[h]', d.h) + '">';
    o += '<text class="vl" x="' + ex + '" y="' + (ey - 36) + '">' + L.front + '</text>';
    o += '<line class="fl" x1="' + (ex - 6) + '" y1="' + (ey + H) + '" x2="' + (ex + MAXW + 6) + '" y2="' + (ey + H) + '"/>';
    o += '<rect class="bd" x="' + x0 + '" y="' + (ey + H * 0.06) + '" width="' + W + '" height="' + (H * 0.8) + '" rx="7"/>';
    o += '<line class="ln" x1="' + (x0 + 6) + '" y1="' + (ey + H * 0.72) + '" x2="' + (x0 + W - 6) + '" y2="' + (ey + H * 0.72) + '"/>';
    for (i = 0; i < ng; i++) { gx = x0 + W * (i + 1) / (ng + 1); o += '<rect class="gp" x="' + (gx - 13) + '" y="' + (ey + H * 0.24) + '" width="26" height="' + (H * 0.16) + '" rx="5"/><line class="ln" x1="' + gx + '" y1="' + (ey + H * 0.4) + '" x2="' + gx + '" y2="' + (ey + H * 0.5) + '"/><line class="ln" x1="' + (gx - 2) + '" y1="' + (ey + H * 0.5) + '" x2="' + (gx + 18) + '" y2="' + (ey + H * 0.56) + '"/>'; }
    o += '<rect class="ln" x="' + (x0 + W * 0.07) + '" y="' + (ey + H * 0.86) + '" width="12" height="' + (H * 0.14) + '" rx="2"/><rect class="ln" x="' + (x0 + W * 0.93 - 12) + '" y="' + (ey + H * 0.86) + '" width="12" height="' + (H * 0.14) + '" rx="2"/>';
    o += dimH(x0, x0 + W, ey - 12, fmtN(d.w) + ' mm');
    o += dimV(x0 + W + 16, ey, ey + H, fmtN(d.h) + ' mm');
    o += '<text class="vl" x="' + px + '" y="' + (py - 36) + '">' + L.plan + '</text>';
    o += '<rect class="bd" x="' + x1 + '" y="' + py + '" width="' + W + '" height="' + D + '" rx="9"/>';
    o += '<rect class="ln" x="' + (x1 + W * 0.05) + '" y="' + (py + D * 0.76) + '" width="' + (W * 0.9) + '" height="' + (D * 0.18) + '" rx="3"/>';
    for (i = 0; i < ng; i++) { gx = x1 + W * (i + 1) / (ng + 1); o += '<circle class="gp" cx="' + gx + '" cy="' + (py + D * 0.62) + '" r="10"/>'; }
    o += '<text class="vl" x="' + (x1 + W / 2) + '" y="' + (py + D + 22) + '" text-anchor="middle">' + L.side + '</text>';
    o += dimH(x1, x1 + W, py - 12, fmtN(d.w) + ' mm');
    o += dimV(x1 + W + 16, py, py + D, fmtN(d.d) + ' mm');
    return o + '</svg>';
  }
  function drawPlan(el) {
    var d = { w: +el.getAttribute('data-w'), d: +el.getAttribute('data-d'), h: +el.getAttribute('data-h') };
    if (!d.w || !d.d || !d.h) return;
    var ng = parseInt(el.getAttribute('data-g'), 10) || 2;
    var L = { front: el.getAttribute('data-front'), plan: el.getAttribute('data-plan'), side: el.getAttribute('data-side'), aria: el.getAttribute('data-aria') };
    el.innerHTML = planSVG(d, ng, 'wide', L) + planSVG(d, ng, 'tall', L);
  }

  /* ---------- diagram leader lines ---------- */
  var diagrams = [];
  function drawLines(box) {
    var svg = box.querySelector('[data-b2b-lines]');
    if (!svg) return;
    if (getComputedStyle(svg).display === 'none') { svg.innerHTML = ''; return; }
    var b = box.getBoundingClientRect();
    if (!b.width) return;
    svg.setAttribute('viewBox', '0 0 ' + b.width + ' ' + b.height);
    var o = '';
    each(box.querySelectorAll('[data-call]'), function (el) {
      var n = el.getAttribute('data-call'), dot = box.querySelector('[data-dot="' + n + '"]'), num = el.querySelector('.xp-n');
      if (!dot || !num) return;
      var nb = num.getBoundingClientRect(), db = dot.getBoundingClientRect();
      var x1 = nb.left + nb.width / 2 - b.left, y1 = nb.top - b.top - 4;
      var x2 = db.left + db.width / 2 - b.left, y2 = db.top + db.height / 2 - b.top;
      var seg = 'x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"';
      o += '<line class="h" ' + seg + '/><line ' + seg + '/><circle cx="' + x1 + '" cy="' + y1 + '" r="2.5"/>';
    });
    svg.innerHTML = o;
  }
  function drawAllLines() { diagrams.forEach(drawLines); }
  function initDiagram(box) {
    diagrams.push(box);
    var img = box.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function () { drawLines(box); });
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { drawLines(box); }); ro.observe(box); }
    else window.addEventListener('resize', function () { clearTimeout(box.__t); box.__t = setTimeout(function () { drawLines(box); }, 80); });
    drawLines(box);
  }

  /* ---------- range table ---------- */
  function setRange(r, g) {
    var has = false;
    each(r.querySelectorAll('[data-rg-show]'), function (t) { if (t.getAttribute('data-rg-show') === g) has = true; });
    if (!has) return;
    each(r.querySelectorAll('[data-rg-show]'), function (t) { t.hidden = t.getAttribute('data-rg-show') !== g; });
    each(r.querySelectorAll('[data-rg]'), function (b) { var on = b.getAttribute('data-rg') === g; b.classList.toggle('xp-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
  }
  function initRange(r) {
    r.addEventListener('click', function (e) { var b = e.target.closest('[data-rg]'); if (b) setRange(r, b.getAttribute('data-rg')); });
  }

  function boot() {
    each(document.querySelectorAll('[data-b2b-plan]'), drawPlan);
    each(document.querySelectorAll('[data-b2b-range]'), initRange);
    each(document.querySelectorAll('[data-b2b-diag]'), initDiagram);
    each(document.querySelectorAll('[data-b2b-buy]'), initBuy);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawAllLines);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
